/**
 * Shared Nodon snackbar / canvas-toast chrome (matches {@link NodonSnackbarProvider}).
 * Keep Design canvas pills and import calibrate toasts visually identical to app snackbars.
 */
export const NODON_SNACKBAR_SURFACE = {
  background: 'rgba(255, 255, 255, 1)',
  border: '1px solid rgba(0, 0, 0, 0.2)',
  boxShadow: '0px 1px 13px 0px rgba(0, 0, 0, 0.1)',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '15.73px',
} as const;

/** Text colors per notistack variant (`hideIconVariant` — no leading icons). */
export const NODON_SNACKBAR_COLOR = {
  default: 'rgba(49, 49, 49, 1)',
  info: 'rgba(52, 128, 216, 1)',
  error: 'rgba(174, 43, 36, 1)',
  warning: 'rgba(221, 137, 36, 1)',
} as const;

/**
 * Solid white pill used by Design canvas toasts (same tokens as app snackbars).
 */
export const getNodonSnackbarPillStyles = () => ({
  ...NODON_SNACKBAR_SURFACE,
  display: 'inline-flex' as const,
  alignItems: 'center' as const,
  gap: 12,
  padding: '6px 16px',
  borderRadius: 4,
  boxSizing: 'border-box' as const,
  backgroundColor: NODON_SNACKBAR_SURFACE.background,
  color: NODON_SNACKBAR_COLOR.default,
});
